import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { cancelMmProgramJob, createMmProgramJob, listMmProgramJobs } from '@/services/api/mm-program-jobs';
import { MM_PROGRAMS_QUERY_KEY } from './use-mm-programs';

export const MM_PROGRAM_JOBS_QUERY_KEY = [...MM_PROGRAMS_QUERY_KEY, 'jobs'] as const;

/** While a job is queued or running, the list refreshes on its own. */
const ACTIVE_REFRESH_MS = 15_000;

const mmProgramJobsQueryOptions = () =>
  queryOptions({
    queryKey: MM_PROGRAM_JOBS_QUERY_KEY,
    queryFn: listMmProgramJobs,
    refetchInterval: (query) => (query.state.data?.jobs.some((job) => job.status === 'queued' || job.status === 'running') ? ACTIVE_REFRESH_MS : false),
  });

export const useMmProgramJobs = () => useQuery(mmProgramJobsQueryOptions());

export const useCreateMmProgramJob = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createMmProgramJob,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: MM_PROGRAM_JOBS_QUERY_KEY }),
  });
};

export const useCancelMmProgramJob = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelMmProgramJob,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: MM_PROGRAM_JOBS_QUERY_KEY }),
  });
};
